import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useToasts } from 'react-toast-notifications';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const Wrapper = styled.div`
  padding: 10px;
  color: #999;
  b {
    color: #000;
    cursor: pointer;
  }
  i {
    cursor: pointer;
    transition: 0.3s ease-in-out;
    &:hover {
      color: #0093dd;
    }
  }
`;

const NoUsersFound: React.FC<{ email: string }> = (props) => {
  const { addToast } = useToasts();
  const [copied, setCopied] = useState(0);

  useEffect(() => {
    copied &&
      addToast('Ссылка скопирована в буфер обмена', {
        appearance: 'success',
        autoDismiss: true,
      });
  }, [copied]);

  return (
    <Wrapper>
      Пользователь <b>{props.email}</b> не найден в системе. <br /> Пригласите его для регистрации -{' '}
      <CopyToClipboard
        text="https://emerald-road-216311.web.app/"
        onCopy={() => setCopied(copied + 1)}
      >
        <i>Скопировать ссылку</i>
      </CopyToClipboard>
    </Wrapper>
  );
};

export default NoUsersFound;
